import React from 'react'
import { SupportedBrands } from 'src/enums'

type CobrandLogoBrand =
  | SupportedBrands.Bmo
  | SupportedBrands.Pnc
  | SupportedBrands.Jpm

interface CobrandLogoProps {
  className?: string
  brandName: CobrandLogoBrand
}

const FILE_NAME_BY_BRAND: Record<CobrandLogoBrand, string> = {
  [SupportedBrands.Pnc]: 'BrandLogoDarkBlue.svg',
  [SupportedBrands.Bmo]: 'BrandLogo.svg',
  [SupportedBrands.Jpm]: 'BrandLogo.svg',
}

const CobrandLogo: React.FC<CobrandLogoProps> = ({ brandName, className }) => {
  return (
    <img
      alt={brandName}
      className={className}
      src={`https://brand-assets.paywithextend.com/${brandName}/${FILE_NAME_BY_BRAND[brandName]}`}
    />
  )
}

export default CobrandLogo
